(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34223,69655],{

/***/ 69655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "47",
        height: "47",
        fill: "none",
        viewBox: "0 0 47 47",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M45.359 5.447A3.252 3.252 0 0045.35.85l.106.106a3.256 3.256 0 00-4.597-.009L23.865 17.941a1.003 1.003 0 01-1.424 0L5.447.947A3.252 3.252 0 00.85.956L.956.85a3.256 3.256 0 00-.009 4.597l16.994 16.994a1.003 1.003 0 010 1.424L.947 40.859a3.252 3.252 0 00.009 4.597L.85 45.35a3.256 3.256 0 004.597.009l16.994-16.994a1.003 1.003 0 011.424 0l16.994 16.994a3.252 3.252 0 004.597-.009l-.106.106a3.256 3.256 0 00.009-4.597L28.365 23.865a1.003 1.003 0 010-1.424L45.359 5.447z"
        })
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 34223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TextBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/page-builder/components/textBlock/styles.module.scss
var styles_module = __webpack_require__(92391);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/svg/closeIcon.tsx
var closeIcon = __webpack_require__(69655);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/lib/shared/routerQueriesToString.ts
var routerQueriesToString = __webpack_require__(78418);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/actionsTracker.ts + 1 modules
var actionsTracker = __webpack_require__(55584);
;// CONCATENATED MODULE: ./src/page-builder/components/textBlock/utils.ts
const getCallsCampaignTitleBasedOnCategory = (categorySlug)=>{
    switch(categorySlug){
        case "water-damage":
            return "Urgent Water Damage Repair";
        default:
            return "";
    }
};

;// CONCATENATED MODULE: ./src/page-builder/components/textBlock/index.tsx












const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
function TextBlock({ props ={}  }) {
    const { query  } = (0,router.useRouter)();
    const { 0: showModal , 1: setShowPartnerPopup  } = (0,react.useState)(false);
    const { text , modalContent , modalTriggerId , modalTitle , scrollToTopTriggerId ,  } = props;
    const { category , visitDetails , routeConfig , formattedTitle , domain , form , headerOffer ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const genericRoute = routeConfig?.replacedPortions?.find((portion)=>portion.key === "[generic-route]")?.value;
    const keyword = routeConfig?.replacedPortions?.find((portion)=>portion.key === "[keyword]")?.value;
    const phoneNumber = (0,sharedUtils/* formatPhoneNumber */.un)((0,sharedUtils/* getPhoneNumber */.ly)(headerOffer?.[0]));
    const textBlockRef = (0,react.useRef)(null);
    const offers = domain?.defaultOffers;
    const affiliateListId = (0,cookies/* getAffiliateListId */.Hf)();
    // Replace [offer:<slug>] placeholders with an internal offer route.
    // This keeps link resolution consistent with existing /offer redirect flow (getOfferUrl)
    const replaceOfferLinkPlaceholders = (input, offersList)=>{
        if (!input || !offersList?.length) return input;
        const getOfferTargetUrl = (offer)=>{
            const categoryId = offer?.category?.id;
            const affLinkId = typeof query?.affLinkId === "string" ? query.affLinkId : "";
            const params = new URLSearchParams();
            if (affiliateListId) {
                params.append("id", String(affiliateListId));
            }
            if (categoryId) {
                params.append("categoryId", String(categoryId));
            }
            params.append("zone", "external");
            if (affLinkId) {
                params.append("affLinkId", affLinkId);
            }
            return `/offer/${offer.slug}?${params.toString()}`;
        };
        return input.replace(/\[offer:([^\]]+)\]/gi, (placeholder, slugRaw)=>{
            const slug = String(slugRaw).trim().toLowerCase();
            const matchedOffer = offersList.find((offer)=>offer.slug?.toLowerCase() === slug);
            if (!matchedOffer) {
                return placeholder;
            }
            return getOfferTargetUrl(matchedOffer);
        });
    };
    (0,react.useEffect)(()=>{
        if (!modalTriggerId || !modalContent) return;
        const el = document.getElementById(modalTriggerId);
        if (!el) return;
        const onClick = ()=>setShowPartnerPopup(true);
        el.addEventListener("click", onClick);
        el.classList.add((styles_module_default())["modal-trigger"]);
        return ()=>{
            el.removeEventListener("click", onClick);
            el.classList.remove((styles_module_default())["modal-trigger"]);
        };
    }, [
        modalTriggerId,
        modalContent
    ]);
    (0,react.useEffect)(()=>{
        if (scrollToTopTriggerId) {
            const scrollTrigger = document.getElementById(scrollToTopTriggerId);
            const handleScrollToTop = ()=>{
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            };
            scrollTrigger?.addEventListener("click", handleScrollToTop);
            return ()=>{
                scrollTrigger?.removeEventListener("click", handleScrollToTop);
            };
        }
    }, [
        scrollToTopTriggerId
    ]);
    // Add event listeners to all links in the text block
    (0,react.useEffect)(()=>{
        if (textBlockRef.current) {
            const links = textBlockRef.current.querySelectorAll("a");
            const handleLinkClick = (event)=>{
                const target = event.currentTarget;
                const href = target.getAttribute("href") || "";
                const sourceLink = new URLSearchParams(href).get("sourceLink") || "";
                if (sourceLink) {
                    (0,actionsTracker/* stackAction */.nm)({
                        action: "click",
                        category: "link",
                        label: "sourceLink",
                        value: sourceLink,
                        createdAt: new Date().toISOString()
                    });
                }
            };
            links.forEach((link)=>{
                link.addEventListener("click", handleLinkClick);
            });
            // Cleanup function to remove event listeners
            return ()=>{
                links.forEach((link)=>{
                    link.removeEventListener("click", handleLinkClick);
                });
            };
        }
    }, [
        text
    ]); // Re-run when text content changes
    const formTitle = (0,sharedUtils/* getTitle */.YQ)({
        category,
        visitDetails,
        formattedTitle,
        textBlocks: domain?.textBlocks,
        stepTitle: form?.steps?.[0]?.title
    });
    const textBlockDescription = domain?.textBlocks && domain?.textBlocks.length && (domain?.textBlocks.find((item)=>item.position === "form_description")?.text);
    const formDescription = textBlockDescription || form?.steps?.[0]?.description;
    const queryString = (0,routerQueriesToString/* gettingQueriesAsString */.r)(query, "inline", [
        "slug"
    ]);
    const callsCampaignTitle = domain?.textBlocks?.find((block)=>block.position === "calls-campaign-title")?.text || formattedTitle || getCallsCampaignTitleBasedOnCategory(category?.slug);
    const titleWithFallback = formattedTitle ?? category?.config?.nativeNetworksPageTitleFallback ?? "";
    const textPlaceholderValues = {
        category: category?.name,
        region: visitDetails.region,
        city: visitDetails?.city,
        keyword,
        genericRoute,
        title: titleWithFallback,
        queryString,
        callsCampaignTitle
    };
    const textWithPlaceholders = text ? (0,sharedUtils/* replacePlaceholders */.wT)(text, textPlaceholderValues) : "";
    const textWithFormTokens = textWithPlaceholders.replace(/\[form-title\]/gi, (0,sharedUtils/* stripHtmlTags */.ju)(formTitle || "")).replace(/\[form-description\]/gi, (0,sharedUtils/* stripHtmlTags */.ju)(formDescription || ""));
    // Replace [offer:<slug>] placeholders with the matching offer URL
    const textWithOfferLinks = replaceOfferLinkPlaceholders(textWithFormTokens, offers);
    // this removes any div that has class "phone-number-hide" and its content if there's [phoneNumber] placeholder in the text and phone number is not available, otherwise replace the [phoneNumber] placeholder with the formatted phone number
    const renderedHtml = phoneNumber ? textWithOfferLinks.replace(/\[phoneNumber\]/gi, phoneNumber) : textWithOfferLinks.replace(/<div>\s*<a[^>]*class="phone-number-hide"[^>]*>[\s\S]*?<\/a>\s*<\/div>/gi, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: textBlockRef,
                dangerouslySetInnerHTML: {
                    __html: renderedHtml
                },
                className: `${(styles_module_default())["text-block"]} prose md:prose-md max-w-none`
            }),
            modalTriggerId && modalContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                onClose: ()=>{
                    setShowPartnerPopup(false);
                },
                active: showModal && !!modalContent,
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
                backdropClosable: true,
                modalStyles: {
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%"
                },
                modalClassName: "h-[90vh] rounded",
                bodyStyles: {
                    overflowY: "scroll"
                },
                width: 900,
                header: modalTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-5 lg:px-9 px-5 modalContainer",
                    dangerouslySetInnerHTML: {
                        __html: modalContent
                    }
                })
            })
        ]
    });
}


/***/ }),

/***/ 92391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-block":"styles_text-block__XkllE","modal-trigger":"styles_modal-trigger__i_piY"};

/***/ })

}]);